import { render, staticRenderFns } from "./PaginationTable.vue?vue&type=template&id=0d271008&"
import script from "./PaginationTable.vue?vue&type=script&lang=js&"
export * from "./PaginationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports